import Dexie from 'dexie'

/* DEXIE */
export class UserDB extends Dexie {
  constructor (dbName: string) {
    super('UserDB')

    this.version(3).stores({
      bookPreferences: 'bookIdKey',
      appSettings: '&key, value',
      bookmarks: '&id, book, page, user',
      annotations: '&id, book, page, user'
    })
  }

  async getSettings (id, key) {
    const settings = await this.bookPreferences.get({bookIdKey: id + key})
    return (settings && settings.value) ? settings.value : undefined
  }

  async getLocale () {
    const locale = await this.appSettings.get({key: 'locale'})
    return (locale && locale.value) ? locale.value : undefined
  }

  async getDictLang () {
    const dictLang = await this.appSettings.get({key: 'lang'})
    return dictLang ? { code: dictLang.code, name: dictLang.name } : null
  }

  async getBubbleAcceptance () {
    const infoAccepted = await this.appSettings.get({key: 'bubbleAccepted'})
    return (infoAccepted && infoAccepted.value) ? infoAccepted.value : undefined
  }

  async getAnnotations (query) {
    const annotations = await this.annotations
      .where(query)
      .filter(ann => ann.action !== 'delete')
      .toArray()

    return annotations || []
  }

}
